import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=538b677d&scoped=true&"
import script from "./addTag.vue?vue&type=script&lang=js&"
export * from "./addTag.vue?vue&type=script&lang=js&"
import style0 from "./addTag.vue?vue&type=style&index=0&id=538b677d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b677d",
  null
  
)

export default component.exports